import React from 'react'
import { Link } from 'react-router-dom'

function MemberCard({tittle,img,reg,id,alt}) {
    return (
        <>
            <div className="memderCard">
                <div className="tittle">{tittle}</div>
                <div className="img">
                    <img src={img} alt={alt} />
                </div>
                <div className="reg"><span>{reg}</span></div>
                <Link to={`/discribe/${id}`}>বিস্তারিত</Link>
            </div>
        </>
    )
}

export default MemberCard
